import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { SupportModalBlockComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-tab-test',
  templateUrl: './tab-test.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabTestComponent extends SupportModalBlockComponent implements OnInit {
  styleClass = 'height_1';

  @Input()
  public text = 'タブテスト';

  reload(): void {}
  init(): void {}
  destroy(): void {}

  constructor(private _common: CommonLibService) {
    super(_common);
  }
}
